export enum AccountingSide {
    DEBIT = "debit",
    CREDIT = "credit",
}

export const ACCOUNTING_SIDE_LABELS: Record<AccountingSide, string> = {
    [AccountingSide.DEBIT]: "Debit",
    [AccountingSide.CREDIT]: "Credit",
};
